// Webpack polyfills for Node.js modules
import * as querystring from 'querystring-es3';

// Make querystring available globally
(window as any).querystring = querystring;

// Polyfill for process
(window as any).process = { env: {} };

// Polyfill for Buffer
(window as any).Buffer = (window as any).Buffer || require('buffer').Buffer;
